class AzSearchBar extends HTMLElement {
  constructor() {
    super();

    this.searchInput = this.querySelector(".az-search-bar-input");
    this.searchList = this.querySelector(".az-predict-search-list");
    this.popularProductsDropdown = this.querySelector(".az-popular-products-search");
    this.serachForm = this.querySelector("#az-search-bar-form");
    this.searchListItemTemplatePrompt = this.querySelector("#az-search-list-prompt-template");
    this.searchListItemTemplateProduct = this.querySelector("#az-search-list-product-template");
    this.searchListNoItemTemplate = this.querySelector("#az-search-list-no-item-template");
    this.searchInputLabel = this.querySelector(".az-search-bar-input-label");
    this.popularSearchs = this.querySelectorAll(".az-popular-search-list-prompts");
    this.seachProductCards = this.querySelectorAll(".az-search-bar-product-card");

    this.baseURL = "https://app.getatomz.com";
    this.debugEnabled = new URL(window.location.href).searchParams.get("azdebug") === "1";

    this.initialSetup();
  }

  initialSetup() {
    this.searchInput.addEventListener("focus", this.openSearchList.bind(this));
    this.searchInput.addEventListener("input", this.debounce(this.loadPredictiveSearch.bind(this), 200));
    this.serachForm.addEventListener("submit", this.handleSubmit.bind(this));

    this.shop = window.Shopify.shop;
    this.timeOffset = this.dataset.timeOffset;
    this.pageTemplate = this.dataset.pageTemplate;
    this.predictionDisbled = this.dataset.predictionDisabled;
    this.autoCompleteField = this.dataset.autoCompleteField;
    this.predictCache = {};
    this.boundCloseSearchList = this.closeSearchList.bind(this);
    this.searchSubmitted = false;
    this.searchSection = document.querySelector("#shopify-section-atomz_header");
    this.searchPanel = this.searchSection ? this.searchSection.querySelector(".az-search-bar-wrapper") : null;
    this.searchTrigger = document.querySelector(".nav-search");
    this.boundHandleSearchIconClick = this.handleSearchIconClick.bind(this);
    this.boundHandleGlobalKeydown = this.handleGlobalKeydown.bind(this);
    this.boundHandleOutsideSearchPanelClick = this.handleOutsideSearchPanelClick.bind(this);

    if (this.pageTemplate == "search") {
      // Results template should start closed; user can reopen via icon toggle.
      document.body.classList.remove("az-search-open");
      this.searchEvent = new CustomEvent("formSubmitted", { detail: { searchQuery: "" } });
      this.searchInput.value = this.getQueryParam("q");
      this.ensureResultsHeadingVisible();
      window.addEventListener("load", () => this.ensureResultsHeadingVisible());
      setTimeout(() => this.ensureResultsHeadingVisible(), 250);
      setTimeout(() => this.ensureResultsHeadingVisible(), 700);
    } else if (this.pageTemplate == "product" && this.getQueryParam("source") == "az-search") {
      document.addEventListener("DOMContentLoaded", () => {
        const journey = sessionStorage.getItem("atomz.ai");
        document.querySelectorAll('form[action="/cart/add"]').forEach((element) => {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = "attributes[_app_source]";
          hiddenInput.value = "atomz_search";
          element.appendChild(hiddenInput);

          const productHandle = decodeURIComponent(window.location.pathname.split("/").pop());
          const searchHistory = journey + ` -> ${this.storeTimeFromUTC()}, product '${productHandle}'`;
          const hiddenSearchHistory = document.createElement("input");
          hiddenSearchHistory.type = "hidden";
          hiddenSearchHistory.name = `attributes[_journey_${this.dataset.productId}_${productHandle}]`;
          hiddenSearchHistory.value = searchHistory;
          element.appendChild(hiddenSearchHistory);
        });
        sessionStorage.setItem("atomz.ai", `${journey} -> ${window.location.pathname}`);
      });
    } else {
      sessionStorage.setItem("atomz.ai", window.location.pathname == "/" ? "/home" : window.location.pathname);
    }

    this.popularSearchs.forEach((li) => {
      li.addEventListener("click", () => {
        this.safeTrackEvent("InSearchSuggestionPromptClicked", {
          promptText: li.querySelector(".az-popular-search-list-text").textContent,
          storeName: this.shop
        });
        setTimeout(() => {
          this.handlePredictionSubmit(li.querySelector(".az-popular-search-list-text").textContent);
        }, 300);
      });
    });

    this.seachProductCards.forEach((card) => {
      card.addEventListener("click", (event) => {
        event.preventDefault();
        this.safeTrackEvent("InSearchProductClicked", {
          productTitle: card.querySelector(".az-search-bar-product-card-title").textContent,
          storeName: this.shop
        });
        setTimeout(() => {
          window.location.href = card.href;
        }, 300);
      });
    });

    this.initIconExpandSearchMode();

    if (this.pageTemplate == "search" && typeof MutationObserver === "function") {
      const target = document.querySelector("atomz-product-grid");
      if (target) {
        const observer = new MutationObserver(() => this.ensureResultsHeadingVisible());
        observer.observe(target, { childList: true, subtree: true });
      }
    }
  }

  ensureResultsHeadingVisible() {
    const query = (this.getQueryParam("q") || "").trim();
    if (!query) return;

    const pageRoot = document.querySelector(".template-search .page-body-content") || document.querySelector(".template-search");
    if (!pageRoot) return;

    const fallbackClass = "az-results-heading az-results-heading-fallback";
    let fallbackHeading = pageRoot.querySelector(".az-results-heading-fallback");
    const realHeadingCandidates = Array.from(
      pageRoot.querySelectorAll(
        'atomz-product-grid h1, .az-results-heading, [class*="results-heading"]'
      )
    ).filter((el) => !el.classList.contains("az-results-heading-fallback"));

    const realHeading = realHeadingCandidates.find((el) => {
      const headingText = (el.textContent || "").trim();
      return /results\s+for/i.test(headingText) || String(el.className).includes("results-heading");
    });

    if (realHeading) {
      realHeading.style.display = "block";
      realHeading.style.visibility = "visible";
      if (fallbackHeading) fallbackHeading.remove();
      return;
    }

    if (!fallbackHeading) {
      fallbackHeading = document.createElement("h1");
      fallbackHeading.className = fallbackClass;
      const knownCountEl = pageRoot.querySelector('.az-results-count, [class*="results-count"], [class*="results-subheading"]');
      const textCountEl = Array.from(pageRoot.querySelectorAll("div, span, p")).find((el) =>
        /\b\d[\d,]*\s+items?\b/i.test((el.textContent || "").trim())
      );
      const countEl = knownCountEl || textCountEl;
      if (countEl) {
        countEl.classList.add("az-results-count-detected");
      }
      const gridRoot = pageRoot.querySelector("atomz-product-grid");
      const parent = (countEl && countEl.parentElement) || gridRoot || pageRoot;
      if (countEl && countEl.parentElement && countEl.parentElement !== fallbackHeading.parentElement) {
        countEl.parentElement.insertBefore(fallbackHeading, countEl);
      } else {
        parent.insertBefore(fallbackHeading, parent.firstChild || null);
      }
    }

    fallbackHeading.textContent = `Results for "${query}"`;
    fallbackHeading.style.display = "block";
    fallbackHeading.style.visibility = "visible";
  }

  storeTimeFromUTC(offsetStr = this.timeOffset) {
    const sign = offsetStr[0];
    const hours = parseInt(offsetStr.substring(1, 3), 10);
    const minutes = parseInt(offsetStr.substring(3, 5), 10);
    let offsetMs = hours * 3600 * 1000 + minutes * 60 * 1000;
    if (sign === "-") {
      offsetMs = -offsetMs;
    }

    const nowUtc = Date.now();
    const targetTime = new Date(nowUtc + offsetMs);
    return targetTime.toISOString().replace("Z", "");
  }

  debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  openSearchList() {
    this.searchSubmitted = false;
    if (this.searchInput.value == "") {
      this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
    } else {
      this.loadPredictiveSearch();
      this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
    }
    document.addEventListener("click", this.boundCloseSearchList);
  }

  closeSearchList(event) {
    // Keep dropdown interactive; close only when click is outside the whole component.
    if (!this.contains(event.target)) {
      this.toggleListDisplay(this.searchList, this.popularProductsDropdown, true);
      this.searchInput.blur();
      document.removeEventListener("click", this.boundCloseSearchList);
    }
  }

  toggleListDisplay(openElement, closeElement, closeBoth = false) {
    if (closeBoth) {
      openElement.style.display = "none";
      openElement.style.opacity = "0";
    } else {
      openElement.style.display = "grid";
      openElement.style.opacity = "1";
    }
    closeElement.style.display = "none";
    closeElement.style.opacity = "0";
  }

  closeSearchUi() {
    this.toggleListDisplay(this.searchList, this.popularProductsDropdown, true);
    this.searchInput.blur();
    document.removeEventListener("click", this.boundCloseSearchList);
  }

  initIconExpandSearchMode() {
    if (!this.searchTrigger || !this.searchSection) return;
    document.body.classList.remove("az-search-open");
    this.searchSection.setAttribute("aria-hidden", "true");
    this.searchTrigger.addEventListener("click", this.boundHandleSearchIconClick);
    document.addEventListener("keydown", this.boundHandleGlobalKeydown);
    // Use capture-phase pointerdown so outside clicks close reliably,
    // even when other components stop click propagation.
    document.addEventListener("pointerdown", this.boundHandleOutsideSearchPanelClick, true);
  }

  handleSearchIconClick(event) {
    event.preventDefault();
    if (document.body.classList.contains("az-search-open")) {
      this.closeExpandedSearchPanel();
      return;
    }
    this.openExpandedSearchPanel();
  }

openExpandedSearchPanel() {
    document.body.classList.add("az-search-open");
    this.searchSection.setAttribute("aria-hidden", "false");
    // Always start fresh — show popular searches/products
    this.searchInput.value = "";
    setTimeout(() => {
      this.searchInput.focus();
      this.openSearchList();
    }, 0);
  }

  closeExpandedSearchPanel() {
    this.closeSearchUi();
    document.body.classList.remove("az-search-open");
    this.searchSection.setAttribute("aria-hidden", "true");
  }

  handleGlobalKeydown(event) {
    const isEditableTarget = (() => {
      const target = event.target;
      if (!target || !(target instanceof Element)) return false;
      return target.matches("input, textarea, select, [contenteditable=''], [contenteditable='true']");
    })();

    const cmdOrCtrlK = (event.key === "k" || event.key === "K") && (event.metaKey || event.ctrlKey);
    const slashKey = event.key === "/" && !event.metaKey && !event.ctrlKey && !event.altKey;

    if (cmdOrCtrlK || (slashKey && !isEditableTarget)) {
      event.preventDefault();
      if (!document.body.classList.contains("az-search-open")) {
        this.openExpandedSearchPanel();
      } else {
        this.searchInput.focus();
        this.searchInput.select();
      }
      return;
    }

    if (event.key !== "Escape") return;
    if (!document.body.classList.contains("az-search-open")) return;
    if (this.searchInput && this.searchInput.value.trim() !== "") {
      // First Escape clears current query; second Escape closes overlay.
      this.searchInput.value = "";
      this.loadPredictiveSearch();
      return;
    }
    this.closeExpandedSearchPanel();
  }

  handleOutsideSearchPanelClick(event) {
    if (!document.body.classList.contains("az-search-open")) return;
    const clickedInsideSearch = this.searchPanel
      ? this.searchPanel.contains(event.target)
      : this.searchSection && this.searchSection.contains(event.target);
    const clickedSearchTrigger = this.searchTrigger.contains(event.target);
    if (!clickedInsideSearch && !clickedSearchTrigger) {
      this.closeExpandedSearchPanel();
    }
  }

  async loadPredictiveSearch() {
    if (this.debugEnabled) {
      console.log("[Atomz][Predictive] Start", {
        query: this.searchInput ? this.searchInput.value : "",
        shop: this.shop,
        pageTemplate: this.pageTemplate,
        predictionDisabled: this.predictionDisbled
      });
    }
    if (this.predictCache[this.searchInput.value] && this.searchInput.value != "") {
      if (this.debugEnabled) {
        console.log("[Atomz][Predictive] Cache hit", {
          query: this.searchInput.value,
          cachedItems: Array.isArray(this.predictCache[this.searchInput.value]) ? this.predictCache[this.searchInput.value].length : "n/a"
        });
      }
      this.showPredictions(this.predictCache[this.searchInput.value]);
    } else if (this.searchInput.value == "") {
      this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
    } else {
      if (this.predictionDisbled == "true") {
        this.showPredictions(null);
      } else {
        try {
          const response = await fetch(`${this.baseURL}/search-service/query-auto-complete`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ user_query: this.searchInput.value, shop: this.shop })
          });

          const predictions = await response.json();
          if (this.debugEnabled) {
            console.log("[Atomz][Predictive] Response", {
              status: response.status,
              ok: response.ok,
              query: this.searchInput.value,
              isArray: Array.isArray(predictions),
              items: Array.isArray(predictions) ? predictions.length : "non-array",
              sample: Array.isArray(predictions) && predictions.length > 0 ? predictions[0] : predictions
            });
          }
          this.showPredictions(predictions);
          this.predictCache[this.searchInput.value] = predictions;
        } catch (error) {
          if (error.name !== "AbortError") {
            console.error("Error loading predictive suggestions:", error);
          }
        }
      }
    }
  }

  safeTrackEvent(name, properties) {
    if (window.appInsights && typeof window.appInsights.trackEvent === "function") {
      window.appInsights.trackEvent({ name, properties });
      if (typeof window.appInsights.flush === "function") {
        window.appInsights.flush();
      }
    }
  }

  async fetchRedirect(query) {
    try {
      const redirectResponse = await fetch(`${this.baseURL}/search-service/get-redirects`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          shop: this.shop,
          query
        })
      });
      const redirectJson = await redirectResponse.json();
      if (this.debugEnabled) {
        console.log("[Atomz][Redirect] Response", {
          status: redirectResponse.status,
          ok: redirectResponse.ok,
          query,
          redirect: redirectJson
        });
      }
      return redirectJson;
    } catch (error) {
      console.warn("Atomz redirect API unavailable, falling back to Shopify search.", error);
      if (this.debugEnabled) {
        console.log("[Atomz][Redirect] Error", { query, error });
      }
      return null;
    }
  }

  showPredictions(predictions) {
    this.searchList.innerHTML = "";
    if (!this.searchSubmitted) {
      this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
    }
    if (predictions == null || predictions.length == 0) {
      const div = this.searchListNoItemTemplate.content.cloneNode(true);
      div.querySelector(".az-predict-search-list-text").innerHTML = `Search For <b>"${this.searchInput.value}"</b>`;
      div.querySelector(".az-predict-search-list-item").addEventListener("click", () => {
        this.handlePredictionSubmit(this.searchInput.value);
      });
      this.searchList.appendChild(div);
    } else {
      let count = 0;
      const promptDiv = document.createElement("div");
      let promptList;
      predictions.forEach((prediction) => {
        if (count > 12) return;

        if (this.autoCompleteField == "title") {
          count++;
          const div = this.searchListItemTemplatePrompt.content.cloneNode(true);
          div.querySelector(".az-predict-search-list-text").textContent = prediction.titleForSuggester;
          div.querySelector(".az-predict-prompt").addEventListener("click", () => {
            this.handlePredictionSubmit(prediction.titleForSuggester);
          });
          promptDiv.appendChild(div);
        } else {
          promptList = prediction.discoveryPrompts;
          if (typeof promptList != "object") return;
          count++;

          const div = this.searchListItemTemplatePrompt.content.cloneNode(true);
          const prompt = promptList[this.getRandomNumber(promptList.length)];
          div.querySelector(".az-predict-search-list-text").textContent = prompt;
          div.querySelector(".az-predict-prompt").addEventListener("click", () => {
            this.handlePredictionSubmit(prompt);
          });
          promptDiv.appendChild(div);
        }
      });

      count = 0;
      const productDiv = document.createElement("div");
      productDiv.classList.add("az-perdict-search-product-grid");
      predictions.forEach((prediction) => {
        if (count > 7) return;
        if (this.autoCompleteField != "title") {
          const promptList2 = prediction.discoveryPrompts;
          if (typeof promptList2 != "object") return;
        }
        count++;

        const div = this.searchListItemTemplateProduct.content.cloneNode(true);
        div.querySelector(".az-predict-search-list-image").src = prediction.featuredMedia + "&width=100&height=100";
        div.querySelector(".az-predict-search-list-image-text").textContent = prediction.titleForSuggester;
        div.querySelector(".az-predict-search-list-image-price").textContent = `${this.formatMoney(prediction.price)}${this.dataset.productCardCurrencyCode == "true" ? " " + window.Shopify.currency.active : ""}`;
        if (prediction.compareAtPrice) {
          div.querySelector(".az-predict-search-list-image-compare-at-price").textContent = `${this.formatMoney(prediction.compareAtPrice)}${this.dataset.productCardCurrencyCode == "true" ? " " + window.Shopify.currency.active : ""}`;
        }
        div.querySelector(".az-link").addEventListener("click", (event) => {
          event.preventDefault();
          this.closeSearchUi();
          this.safeTrackEvent("InSearchProductClicked", {
            productTitle: prediction.titleForSuggester,
            storeName: this.shop
          });
          setTimeout(() => {
            window.location.href = `/products/${prediction.handle}?source=az-search`;
          }, 300);
        });
        productDiv.appendChild(div);
      });

      this.searchList.appendChild(promptDiv);
      this.searchList.appendChild(productDiv);
    }
  }

  formatMoney(price) {
    if (price === null || price === undefined) return "";

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(price * 100, this.dataset.productCardMoneyFormat == "default" ? window.Shopify.money_format : this.dataset.productCardMoneyFormat);
    }

    const formatted = this.formatMoneyCustom(price * 100, this.dataset.productCardMoneyFormat == "default" ? "${{ amount }}" : this.dataset.productCardMoneyFormat);
    if (formatted !== null) return formatted;

    return price.toLocaleString("en-US", {
      style: "currency",
      currency: window.Shopify.currency.active
    });
  }

  formatMoneyCustom(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      const parts = number.split(".");
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : "";

      return dollars + centsPart;
    }

    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = null;
        break;
    }

    if (value === null) return null;
    return format.replace(placeholderRegex, value);
  }

  getRandomNumber(max) {
    return Math.floor(Math.random() * max);
  }
async handleSubmit(event) {
    event.preventDefault();
    if (this.searchInput.value == "") return;
    if (this.debugEnabled) {
      console.log("[Atomz][Submit] Form submit", {
        query: this.searchInput.value,
        pageTemplate: this.pageTemplate,
        action: this.serachForm ? this.serachForm.action : null
      });
    }
    const redirectResponseJson = await this.fetchRedirect(this.searchInput.value);

    if (redirectResponseJson) {
      window.location.href = redirectResponseJson;
      return;
    }

    if (this.pageTemplate == "search") {
      this.triggerEvent(this.searchInput.value);
      this.toggleListDisplay(this.searchList, this.popularProductsDropdown, true);
      this.closeExpandedSearchPanel();
      setTimeout(() => {
        this.searchInput.blur();
      }, 0);
    } else if (!redirectResponseJson) {
      this.serachForm.submit();
    }
  }

  async handlePredictionSubmit(word) {
    this.closeSearchUi();
    if (this.debugEnabled) {
      console.log("[Atomz][Submit] Prediction submit", {
        query: word,
        pageTemplate: this.pageTemplate
      });
    }
    const redirectResponseJson = await this.fetchRedirect(word);
    if (redirectResponseJson) {
      window.location.href = redirectResponseJson;
      return;
    }

    if (this.pageTemplate == "search") {
      this.triggerEvent(word);
      this.searchInput.value = word;
      this.closeExpandedSearchPanel();
    } else if (!redirectResponseJson) {
      this.searchInput.value = word;
      this.serachForm.submit();
    }
  }

  triggerEvent(searchQuery) {
    this.searchSubmitted = true;
    this.searchEvent.detail.searchQuery = searchQuery;
    this.serachForm.dispatchEvent(this.searchEvent);
    this.updateQueryParam("q", searchQuery);
  }

  getQueryParam(param) {
    const urlObj = new URL(window.location.href);
    return urlObj.searchParams.get(param);
  }

  updateQueryParam(param, newVal) {
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.set(param, newVal);
    window.history.replaceState(null, "", urlObj.toString());
  }
}

customElements.define("az-search-bar", AzSearchBar);

class AnimatedText extends HTMLElement {
  constructor() {
    super();
    this.text = this.dataset.text;
    if (this.text) {
      this.text = this.text.split(",");
      this.textElemet = this.querySelector("#animation-text");
      this.textElemet.addEventListener("animationiteration", this.changeText.bind(this));
      this.currentIndex = 1;
    }
  }

  changeText() {
    this.textElemet.innerHTML = this.text[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.text.length;
  }
}

customElements.define("animate-text", AnimatedText);

class AtomzSticky extends HTMLElement {
  constructor() {
    super();
    this.headerContainer = document.querySelector(".header-wrapper, .main-header-wrap");
    this.enableSticky = this.dataset.enableSticky;
    this.divType = this.dataset.stickyType;
    this.element = this;
    this.setInitial();
    this.setupSABAIStickyOffsets();
  }

  setInitial() {
    const searchBarSticky = document.querySelector('atomz-sticky[data-sticky-type="search-bar"]');
    let vatiableLength = 0;
    if (this.divType == "suggestions") {
      vatiableLength = searchBarSticky ? searchBarSticky.offsetHeight : 0;
      this.element.classList.add("az-sticky-div");
    } else if (this.divType == "discoveryPrompt") {
      vatiableLength = searchBarSticky ? searchBarSticky.offsetHeight : 0;
      this.discoveryPromptSection = this.closest('section[id^="shopify-section-"]');
      if (this.discoveryPromptSection) {
        this.discoveryPromptSection.classList.add("az-sticky-div", "az-discovery-prompt-contianer");
        this.element = this.discoveryPromptSection;
      }
    } else {
      this.searchBarSection = this.closest('section[id^="shopify-section-"]');
      if (this.searchBarSection) {
        this.searchBarSection.classList.add("az-sticky-div", "az-search-bar");
        this.element = this.searchBarSection;
      }
    }

    if (this.enableSticky != "true") return;

    const stickyType = this.headerContainer ? this.headerContainer.dataset.stickyType : null;
    if (!stickyType) {
      // SABAI header doesn't expose Atomz sticky metadata; CSS variables handle offsets.
      this.element.style.removeProperty("top");
      return;
    }

    this.element.style.top = `${vatiableLength}px`;

    if (stickyType == "always") {
      this.element.style.top = `${this.headerContainer.offsetHeight + vatiableLength}px`;
    } else if (stickyType == "on-scroll-up") {
      let lastScrollTop = 0;
      const headerHeight = this.headerContainer.offsetHeight;
      window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        if (scrollTop > lastScrollTop) {
          this.element.style.top = `${vatiableLength}px`;
        } else {
          this.element.style.top = `${headerHeight + vatiableLength}px`;
        }
        lastScrollTop = scrollTop;
      });
    } else if (stickyType == "reduce-logo-size") {
      const logoReduceFunction = () => {
        this.element.style.top = `${this.headerContainer.offsetHeight + vatiableLength}px`;
      };
      window.addEventListener("scroll", logoReduceFunction);
    }
  }

  throttle(func, wait = 100) {
    let timer = null;
    let lastArgs = null;
    return (...args) => {
      lastArgs = args;
      if (timer) return;
      timer = setTimeout(() => {
        func(...lastArgs);
        timer = null;
      }, wait);
    };
  }

  setupSABAIStickyOffsets() {
    let lastSearchOffset = null;
    let lastPromptsOffset = null;

    const updateOffsets = () => {
      const headerCandidates = Array.from(
        document.querySelectorAll(
          ".main-header-wrap, .header-wrapper, .main-header, .main-header-wrap .main-header, .pxs-announcement-bar, .pxs-announcement-bar.topbar-enabled"
        )
      );
      const searchSection = document.querySelector("#shopify-section-atomz_header");

      const headerBottom = headerCandidates.reduce((max, el) => {
        const rect = el.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0) return max;
        if (rect.top > 220) return max;
        const bottom = Math.round(rect.bottom);
        return bottom > max ? bottom : max;
      }, 0);
      const searchHeight = searchSection ? Math.round(searchSection.getBoundingClientRect().height) : 60;

      const searchOffset = Math.max(0, headerBottom);
      const promptsOffset = searchOffset + searchHeight;

      if (lastSearchOffset === null || Math.abs(searchOffset - lastSearchOffset) >= 1) {
        document.documentElement.style.setProperty("--az-search-offset", `${searchOffset}px`);
        lastSearchOffset = searchOffset;
      }
      if (lastPromptsOffset === null || Math.abs(promptsOffset - lastPromptsOffset) >= 1) {
        document.documentElement.style.setProperty("--az-prompts-offset", `${promptsOffset}px`);
        lastPromptsOffset = promptsOffset;
      }
    };

    const throttledUpdate = this.throttle(updateOffsets, 80);
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateOffsets();
        ticking = false;
      });
    };

    const watchDynamicHeaderChanges = () => {
      const targets = Array.from(
        document.querySelectorAll(
          ".main-header-wrap, .header-wrapper, .main-header, .main-header-wrap .main-header, .pxs-announcement-bar, .pxs-announcement-bar.topbar-enabled"
        )
      );

      if (typeof MutationObserver === "function") {
        const observer = new MutationObserver(() => {
          window.requestAnimationFrame(updateOffsets);
        });
        targets.forEach((node) => {
          observer.observe(node, {
            attributes: true,
            attributeFilter: ["class", "style"],
            childList: true,
            subtree: true
          });
        });
      }

      targets.forEach((node) => {
        node.addEventListener("transitionend", updateOffsets, { passive: true });
        node.addEventListener("animationend", updateOffsets, { passive: true });
      });
    };

    const runInitialPasses = () => {
      updateOffsets();
      window.requestAnimationFrame(() => {
        updateOffsets();
        window.requestAnimationFrame(updateOffsets);
      });
      setTimeout(updateOffsets, 120);
      setTimeout(updateOffsets, 350);
      setTimeout(updateOffsets, 700);
    };

    window.addEventListener("load", throttledUpdate);
    document.addEventListener("DOMContentLoaded", runInitialPasses);
    window.addEventListener("pageshow", runInitialPasses);
    window.addEventListener("resize", throttledUpdate);
    window.addEventListener("scroll", onScroll, { passive: true });
    watchDynamicHeaderChanges();
    runInitialPasses();
  }
}

customElements.define("atomz-sticky", AtomzSticky);

class AtomzDiscoveryPrompts extends HTMLElement {
  constructor() {
    super();

    this.pageDataElement = document.querySelector("#page-data");
    this.baseURL = "https://app.getatomz.com";

    this.initialSetup();
  }

  initialSetup() {
    this.pageDataJson = JSON.parse(this.pageDataElement.textContent);
    this.shop = window.Shopify.shop;
    this.suggestions = [];

    if (this.pageDataJson.pageType == "search") {
      this.productGrid = document.querySelector("atomz-product-grid");
      if (this.productGrid) return;
    }
    this.fetchSuggestions();
  }

  async fetchSuggestions() {
    try {
      if (window.atomzABTestGroup == "B") {
        return;
      }

      const gptResponse = await fetch(`${this.baseURL}/search-service/query-discovery-propmts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ page_data: this.pageDataJson, shop: this.shop })
      });

      const gptResponseJson = await gptResponse.json();

      if (gptResponseJson.error || gptResponseJson == null) return;

      if (gptResponse.ok) {
        if (gptResponseJson.value.includes("|")) {
          this.suggestions = this.getRandomElements(gptResponseJson.value.split("|"), gptResponseJson.numberOfResults);
        } else if (gptResponseJson.value.includes(",")) {
          this.suggestions = this.getRandomElements(gptResponseJson.value.split(","), gptResponseJson.numberOfResults);
        }

        if (typeof this.suggestions !== "string") {
          this.showSuggestions();
        if (window.appInsights && typeof window.appInsights.trackEvent === "function") {
          window.appInsights.trackEvent({
            name: "DiscoveryPromptDisplayed",
            properties: {
              storeName: this.shop,
              pageType: this.pageDataJson.pageType,
              pageTitle: this.pageDataJson.title
            }
          });
          if (typeof window.appInsights.flush === "function") window.appInsights.flush();
        }
        }
      }
    } catch (error) {}
  }

  getRandomElements(arr, num) {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, num);
  }

  showSuggestions() {
    for (const suggestion of this.suggestions) {
      const suggestionDiv = document.createElement("a");
      suggestionDiv.href = `/search?q=${encodeURIComponent(suggestion).replace(/%20/g, "+")}&p=${encodeURIComponent(this.pageDataJson.pageType)}`;
      suggestionDiv.classList = "az-discovery-prompts-text";
      suggestionDiv.textContent = suggestion;
      suggestionDiv.addEventListener("click", (event) => {
        event.preventDefault();
        if (window.appInsights && typeof window.appInsights.trackEvent === "function") {
          window.appInsights.trackEvent({
            name: "DiscoveryPromptClicked",
            properties: {
              promptText: suggestion,
              storeName: this.shop,
              numberOFPrompts: this.suggestions.length,
              pageType: this.pageDataJson.pageType,
              pageTitle: this.pageDataJson.title
            }
          });
          if (typeof window.appInsights.flush === "function") window.appInsights.flush();
        }
        setTimeout(() => {
          window.location.href = `/search?q=${encodeURIComponent(suggestion).replace(/%20/g, "+")}&p=${encodeURIComponent(this.pageDataJson.pageType)}`;
        }, 300);
      });
      suggestionDiv.addEventListener("contextmenu", () => {
        if (window.appInsights && typeof window.appInsights.trackEvent === "function") {
          window.appInsights.trackEvent({
            name: "DiscoveryPromptClicked",
            properties: {
              promptText: suggestion,
              storeName: this.shop,
              numberOFPrompts: this.suggestions.length,
              pageType: this.pageDataJson.pageType,
              pageTitle: this.pageDataJson.title
            }
          });
          if (typeof window.appInsights.flush === "function") window.appInsights.flush();
        }
      });
      this.appendChild(suggestionDiv);
    }
    this.classList.remove("az-hidden");
  }
}

customElements.define("atomz-discovery-prompts", AtomzDiscoveryPrompts);
